import React from "react";

export default function RecordRow({ label, value, location = false, locationData = {} }) {
  const formatAddress = () => {
    if (location && locationData) {
      const { city, state, country } = locationData;

      const addressParts = [city, state, country].filter((part) => part);

      if (addressParts.length === 0) {
        return "-";
      }
      return addressParts.join(", ");
    } else {
      return "-";
    }
  };
  if (location) {
    return (
      <div className="flex items-center">
        <span className="text-sm block">{label}:</span>
        <span className="text-[#101828] text-sm font-semibold break-words block ml-2">{formatAddress()}</span>
      </div>
    );
  }
  return (
    <>
      <div className="flex items-center">
        <span className="text-sm block">{label}:</span>
        <span className="text-[#101828] text-sm font-semibold break-words block ml-2">
          {value ? value : "-"}
        </span>
      </div>
    </>
  );
}
